import React from 'react';

const Usecasepopup = () => {
  return (
    <div className="bg-[#062B37] text-green-300 px-6 py-8 md:px-10 max-h-[80vh] pb-12 overflow-y-auto rounded-lg">
      {/* <h2 className="text-xl font-bold mb-6 text-center text-green-300">
        Use Case – BRSR Value Chain Assessment for Indian Listed Companies
      </h2> */}

      <h3 className="text-base font-semibold mb-2 pl-4 text-green-300">Company Requirement</h3>
      <div className="pl-4 space-y-4 text-white text-base">
        <p>
          An Indian company is reporting on the essential BRSR indicators across the 9 principles recommended by SEBI.
          However, their investors are requesting greater disclosure on the value chain sustainability practices as required
          for the BRSR leadership indicators. Specifically, they are requesting disclosure on:
        </p>

        <p>
          <strong className="">Section B</strong> Policy and Management Process covering value chain partners (Q3)
        </p>
        <p>
          <strong className="">Section C / Principle 1</strong> Awareness Programs for value chain partners (Leadership indicator Q1)
        </p>
        <p className="text-justify">
          <strong className=" text-justify">Section C / Principle 3</strong> (Businesses should respect and promote the well-being of all employees,
          including those in their value chains): Leadership indicators on assessment of value chain partners on statutory
          dues (Q2), health & safety (Q5), working conditions (Q5), and corrective actions to address risks (Q6).
        </p>
        <p className='text-justify'>
          <strong className="">Section C / Principle 5</strong> (Businesses should respect and promote human rights): Leadership indicators on assessment of value chain partners on sexual harassment, discrimination, child labour, forced labour, wages, etc. (Q4), and corrective actions to address risks (Q5).
        </p>
        <p className="text-justify">
          <strong className="">Section C / Principle 6</strong> (Businesses should respect and make efforts to protect and restore the environment): Leadership indicators on adverse environmental impacts arising from the value chain (Q6 and Q7).
        </p>
      </div>

      <h3 className="text-base font-semibold mt-8 mb-2 pl-4 text-green-300">Use Case: Leveraging Ethosflo for Value Chain Sustainability Insights</h3>
      <div className="pl-4 space-y-4 text-base text-justify text-white">
        <p>
          The company turned to the <strong>Ethosflo platform</strong> to gain deeper visibility into the sustainability
          practices of its value chain partners. By using Ethosflo, the organization was able to assess all the abovementioned
          sustainability indicators at no cost, enabling them to report effectively against leadership indicators.
        </p>
        <p>
          In addition, the platform provided insights into environmental, social, and governance (ESG) metrics not currently
          required under the BRSR framework—but which are mandated by international regulations in regions such as the EU,
          USA, Australia, and Canada.
        </p>
        <p>
          This proactive approach not only enhanced their current disclosures but also helped them prepare for emerging
          requirements.
        </p>
      </div>
    </div>
  );
};

export default Usecasepopup;